import React from "react";
import { Grid, Card, Segment } from "semantic-ui-react";
import { Line, Polar, Pie } from "react-chartjs-2";

const PreregisterStats = ({ preregisterStats }) => (
	<>
		{preregisterStats.center && (
			<Grid.Column mobile={16} tablet={16} computer={4} style={{ overflowY: "auto" }}>
				<Segment className="card-chart">
					<h5 className="card-details">En centre / hors centre</h5>
					<Card.Content>
						<div className="chart-zone">
							{/* copy of a readonly object to make it readable by react-chartjs-2 */}
							<Pie data={JSON.parse(JSON.stringify(preregisterStats.center))} />
						</div>
					</Card.Content>
				</Segment>
			</Grid.Column>
		)}
		{preregisterStats.valid && (
			<Grid.Column mobile={16} tablet={16} computer={4} style={{ overflowY: "auto" }}>
				<Segment className="card-chart">
					<h5 className="card-details">Pré-inscriptions valides</h5>
					<Card.Content>
						<div className="chart-zone">
							{/* copy of a readonly object to make it readable by react-chartjs-2 */}
							<Pie data={JSON.parse(JSON.stringify(preregisterStats.valid))} />
						</div>
					</Card.Content>
				</Segment>
			</Grid.Column>
		)}
		{preregisterStats.myLab && (
			<Grid.Column mobile={16} tablet={16} computer={4} style={{ overflowY: "auto" }}>
				<Segment className="card-chart">
					<h5 className="card-details">Patient MyLab</h5>
					<Card.Content>
						<div className="chart-zone">
							{/* copy of a readonly object to make it readable by react-chartjs-2 */}
							<Pie data={JSON.parse(JSON.stringify(preregisterStats.myLab))} />
						</div>
					</Card.Content>
				</Segment>
			</Grid.Column>
		)}
		{preregisterStats.gender && (
			<Grid.Column mobile={16} tablet={16} computer={4} style={{ overflowY: "auto" }}>
				<Segment className="card-chart">
					<h5 className="card-details">Genre des patients</h5>
					<Card.Content>
						<div className="chart-zone">
							{/* copy of a readonly object to make it readable by react-chartjs-2 */}
							<Pie data={JSON.parse(JSON.stringify(preregisterStats.gender))} />
						</div>
					</Card.Content>
				</Segment>
			</Grid.Column>
		)}
		{preregisterStats.countBy && (
			<Grid.Column mobile={16} tablet={16} computer={8} style={{ overflowY: "auto" }}>
				<Segment className="card-chart">
					<h5 className="card-details">Pré-inscriptions</h5>
					<Card.Content>
						<div className="chart-zone">
							{/* copy of a readonly object to make it readable by react-chartjs-2 */}
							<Line data={JSON.parse(JSON.stringify(preregisterStats.countBy))} />
						</div>
					</Card.Content>
				</Segment>
			</Grid.Column>
		)}
		{preregisterStats.ages && (
			<Grid.Column mobile={16} tablet={16} computer={8} style={{ overflowY: "auto" }}>
				<Segment className="card-chart">
					<h5 className="card-details">Tranches d'âge des patients</h5>
					<Card.Content>
						<div className="chart-zone">
							{/* copy of a readonly object to make it readable by react-chartjs-2 */}
							<Polar data={JSON.parse(JSON.stringify(preregisterStats.ages))} />
						</div>
					</Card.Content>
				</Segment>
			</Grid.Column>
		)}
	</>
);

export default PreregisterStats;
